import { Component, DestroyRef, ViewChild, OnInit, inject } from '@angular/core';
import { takeUntilDestroyed } from "@angular/core/rxjs-interop";
import { RnDroppedPackagesVM } from '../../../services/rnapi2-service/models/models';
import { ModalComponent } from '@rn-platform/frontend-shared-ui-common';
import { CloseOrganizationConfiguration } from './close-organization-configuration.model';
import { CloseOrganizationModalService } from './close-organization-modal.service';

@Component({
  selector: 'app-close-organization-dialog',
  templateUrl: './close-organization-dialog.component.html',
  styleUrls: ['./close-organization-dialog.component.scss'],
  standalone: false
})
export class CloseOrganizationDialogComponent implements OnInit {
  private _configuration: CloseOrganizationConfiguration;  
  @ViewChild('modalRef') modalComponent: ModalComponent;
  droppedPackages: RnDroppedPackagesVM[];
  userCount: number;
  orgName: string;
  orgHasSubOrgs: boolean;
  hasPkgActions = false;
  hasUserActions = false;
  actionText = '';
  userText = '';
  private readonly closeOrganizationModalService = inject(CloseOrganizationModalService);
  private readonly destroyRef = inject(DestroyRef);

  ngOnInit(): void {
    this.closeOrganizationModalService.modalState$.pipe(takeUntilDestroyed(this.destroyRef)).subscribe((data) => {
      if (!data) return;
      if (data?.config) {
        this._configuration = data?.config;
        this.droppedPackages = this._configuration?.droppedPackages;
        this.userCount = this._configuration?.userCount;
        this.orgName = this._configuration?.orgName;
        this.orgHasSubOrgs = this._configuration?.orgHasSubOrgs;
        this.initialize();
      }
      if (data?.isOpen) {
        this.open();
      } else {
        this.close();
      }
    });
  }

  private initialize(): void {
    this.hasPkgActions = this.droppedPackages && this.droppedPackages.length > 0;
    this.hasUserActions = this.userCount > 0;
    this.actionText =
      (this.droppedPackages.length === 1 && (!this.userCount || this.userCount === 0)) ||
      this.droppedPackages.length === 0
        ? 'action'
        : 'actions';
    this.userText = this.userCount === 1 ? 'User' : 'Users';
  }

  public open(): void {
    this.modalComponent?.open();
  }

  public close(): void {
    this._configuration?.onCancel();
    this.modalComponent?.close();
  }

  public confirm(): void {
    this._configuration?.onClose();
    this.modalComponent?.close();
  }
}
